import styled from "styled-components";
import { theme } from "../../../../../constants/StyledComponents";

export const StyledProfessionalPortrait = styled.div`
  & .form-content {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  & .content-grid {
    display: grid;
    gap: 20px;
    align-items: center;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));

    & .linkedin-card-container {
      padding-right: 20px;
      border-right: 2px solid ${theme.colors.page_background};
      grid-column: span 2;
    }
  }

  & .content-row {
    display: flex;
    flex-direction: row;
    gap: 20px;
    width: 100%;
    box-sizing: content-box;
  }
  & .empty-content {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const StyledLinkedinCardIconContainer = styled.div<{
  onClick?: () => void;
}>`
  padding: 4px;
  background-color: ${theme.colors.white};
  border-radius: ${theme.variables.border_radius_1};
  cursor: ${({ onClick }) => (onClick ? "pointer" : "inherit")};
`;

export const StyledBtnProfessionalPortrait = styled.div`
  display: flex;
  justify-content: flex-end;
`;
